import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["formCard", "formTitle", "formCardBody", "cpfInput", "nameInput", "birthdateInput", "nextBtn", "errorMessage", "linkInput",
    "sexDropdown", "sexDropdownBtn", "sexInput", "sexList", "patientCheck", "sponsorCheck", "saveAccountBtn",
    "dddInput", "phoneInput", "kindPhoneDropdown", "kindPhoneDropdownBtn", "kindPhoneInput", "kindPhoneList",
    "addressInput", "kindEmailDropdown", "kindEmailDropdownBtn", "kindEmailInput", "kindEmailList", "zipInput", "kindAddressDropdown", "kindAddressDropdownBtn", "kindAddressInput",
    "kindAddressList", "streetInput", "numberInput", "complementInput", "districtInput", "stateInput", "stateFilter", "cityInput", "cityFilter", "nextBtn",
    "savePhoneBtn", "saveEmailBtn", "saveAddressBtn", "signatoryAccountCheckbox", "financialAccountCheckbox", "mrrInput", "mrrDropdown", "mrrDiv", "invoiceAccountCheckbox",
    "ibgeInput", "doctorCheckbox", "operationalCheckbox", "financialCheckbox", "administrativeCheckbox", "legalCheckbox", "technicalCheckbox"]

  connect() {
    this.controllerName = `operations--onboards--show--parties--account--save`
    this.canRequest = true
    this.account_id = ``
    this.partyConfirmed = false
    this.party = {}

    this.account = { phone: {}, email: {}, address: {} }
    this.send_address = { current_user: {}, record: {}, address: {} }
  }

  disconnect() {
    this.stopAllRefreshing()
  }

  saveAccount() {
    this.send_account_data = { current_user: {}, account: {}, kind: {} }
    this.saveAccountBtnTarget.disabled = true
    this.stopAccountRefreshing()

    if (this.accountActionMode == "edit") { this.send_account_data.account.id = this.account_id }
    this.send_account_data.account.name = this.nameInputTarget.value.trim()
    this.send_account_data.account.cpf = this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(this.cpfInputTarget.value)
    this.send_account_data.account.sex = this.sexInputTarget.dataset.sex
    this.send_account_data.account.birthdate = this.getControllerByIdentifier("app--helpers--date").transformNumberDate(this.birthdateInputTarget.value)
    this.send_account_data.kind.kind = `doctor`

    this.send_account_data.current_user.current_user_id = this.application.current_user.id
    this.send_account_data.current_user.feature = `operation_onboard_parties`

    this.requestSaveAccount()
  }

  requestSaveAccount() {
    if (this.accountActionMode == "new") {
      var url = "/users/accounts/entities/create"
      var method = "POST"
    } else if (this.accountActionMode == "edit") {
      var url = "/users/accounts/entities/update"
      var method = "PUT"
    }

    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_account_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.account = response.data.cln
          controller.account_id = controller.account.id
          controller.saveOnboardParty()
        } else {
          controller.saveAccountBtnTarget.disabled = false
        }
        
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  saveOnboardParty() {
    this.send_party_data = { current_user: {}, party: {} }

    if (this.onboardActionMode == "edit") { this.send_party_data.party.id = this.party.id }
    this.send_party_data.party.onboard_id = this.application.onboard.id
    this.send_party_data.party.party_id = this.account.id
    this.send_party_data.party.party_type = this.account.class_type
    this.send_party_data.party.party_name = this.account.name
    this.send_party_data.party.party_number = this.account.cpf
    this.send_party_data.party.party_kind = `individual`

    this.send_party_data.party.party_financial = this.financialCheckboxTarget.checked
    this.send_party_data.party.party_administrative = this.administrativeCheckboxTarget.checked
    this.send_party_data.party.party_operational = this.operationalCheckboxTarget.checked
    this.send_party_data.party.party_doctor = this.doctorCheckboxTarget.checked
    this.send_party_data.party.party_legal = this.legalCheckboxTarget.checked
    this.send_party_data.party.party_technical = this.technicalCheckboxTarget.checked

    this.send_party_data.current_user.current_user_id = this.application.current_user.id
    this.send_party_data.current_user.feature = `operation_onboard_parties`

    this.requestSaveOnboardParty()
  }

  requestSaveOnboardParty() {
    if (this.onboardActionMode == "new") {
      var url = "/operations/onboards/parties/create"
      var method = "POST"
    } else if (this.onboardActionMode == "edit") {
      var url = "/operations/onboards/parties/update"
      var method = "PUT"
    }

    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_party_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.stopAccountRefreshing()
          var party = response.data.cln
          controller.partyConfirmed = true
          if (controller.onboardActionMode == `new`) {
            controller.application.parties[controller.application.parties.length] = party
          } else if (controller.onboardActionMode == `edit`) {
            controller.application.parties.forEach((element, i) => {
              if (element.id == party.id) {
                controller.application.parties.splice(controller.application.parties.indexOf(element), 1, party)
              }
            })
          }

          controller.application.onboard.parties = controller.application.parties
          controller.doContactFormHtml()
          controller.getControllerByIdentifier("operations--onboards--show--parties--account--index").doDataTable()
          controller.getControllerByIdentifier("operations--onboards--show--entity").setParties()
        } else {
          controller.partyConfirmed = false
        }

        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  savePhone() {
    this.stopPhoneRefreshing()

    this.send_phone = { current_user: {}, record: {}, phone: {} }

    if (this.phoneActionMode == "edit") { this.send_phone.phone.id = this.account.phone.id }

    this.send_phone.phone.ddd = this.dddInputTarget.value.trim()
    this.send_phone.phone.number = this.getControllerByIdentifier("app--helpers--numbers").fromPhoneToNumber(this.phoneInputTarget.value.trim())
    this.send_phone.phone.uniq_number = this.dddInputTarget.value + this.getControllerByIdentifier("app--helpers--numbers").fromPhoneToNumber(this.phoneInputTarget.value)
    this.send_phone.phone.kind = this.kindPhoneInputTarget.dataset.kind
    this.send_phone.phone.is_main = true
    this.send_phone.record.account_id = this.account.id
    this.send_phone.record.record_type = `account_entities`
    
    this.send_phone.current_user.current_user_id = this.application.current_user.id
    this.send_phone.current_user.feature = `operation_onboard_parties`

    this.requestPhoneSave()
  }

  requestPhoneSave() {
    if (this.phoneActionMode == "new") {
      var url = "/users/accounts/phones/create"
      var method = "POST"
    } else if (this.phoneActionMode == "edit") {
      var url = "/users/accounts/phones/update"
      var method = "PUT"
    }
    var controller = this
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_phone) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.stopPhoneRefreshing()
        if (response.save) {
          var phone = response.data.cln
          controller.account.phone = phone
          controller.savePhoneBtnTarget.innerText = `Confirmado`
          controller.savePhoneBtnTarget.disabled = true
          controller.phoneConfirmed = true
        } else {
          controller.savePhoneBtnTarget.innerText = `Salvar`
          controller.savePhoneBtnTarget.disabled = false
          controller.phoneConfirmed = false
        }

        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  saveEmail() {
    this.stopEmailRefreshing()
    this.send_email = { current_user: {}, record: {}, email: {} }

    if (this.emailActionMode == "edit") { this.send_email.email.id = this.account.email.id }

    this.send_email.email.address = this.addressInputTarget.value.trim()
    this.send_email.email.kind = this.kindEmailInputTarget.dataset.kind
    this.send_email.email.is_main = true
    this.send_email.record.account_id = this.account.id
    this.send_email.record.record_type = `account_entities`

    this.send_email.current_user.current_user_id = this.application.current_user.id
    this.send_email.current_user.feature = `operation_onboard_parties`

    this.requestEmailSave()
  }

  requestEmailSave() {
    if (this.emailActionMode == "new") {
      var url = "/users/accounts/emails/create"
      var method = "POST"
    } else if (this.emailActionMode == "edit") {
      var url = "/users/accounts/emails/update"
      var method = "PUT"
    }
    var controller = this
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_email) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.stopEmailRefreshing()
        if (response.save) {
          var email = response.data.cln
          controller.account.email = email
          controller.saveEmailBtnTarget.innerText = `Confirmado`
          controller.saveEmailBtnTarget.disabled = true
          controller.emailConfirmed = true
        } else {
          controller.saveEmailBtnTarget.innerText = `Salvar`
          controller.saveEmailBtnTarget.disabled = false
          controller.emailConfirmed = false
        }

        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  saveAddress() {
    this.stopAddressRefreshing()
    this.send_address = { current_user: {}, record: {}, address: {} }

    if (this.addressActionMode == "edit") { this.send_address.address.id = this.account.address.id }

    this.send_address.address.postal_code = this.getControllerByIdentifier("app--helpers--numbers").fromZipToNumber(this.zipInputTarget.value)
    this.send_address.address.street = this.streetInputTarget.value.trim()
    this.send_address.address.number = this.numberInputTarget.value.trim()
    this.send_address.address.complement = this.complementInputTarget.value.trim()
    this.send_address.address.district = this.districtInputTarget.value.trim()
    this.send_address.address.city = this.cityInputTarget.value.trim()
    this.send_address.address.state = this.stateInputTarget.value.trim()
    this.send_address.address.ibge = this.ibgeInputTarget.value.trim()
    this.send_address.address.country = `Brasil`
    this.send_address.address.kind = this.kindAddressInputTarget.dataset.kind
    this.send_address.address.is_main = true
    this.send_address.record.account_id = this.account.id
    this.send_address.record.record_type = `account_entities`

    this.send_address.current_user.current_user_id = this.application.current_user.id
    this.send_address.current_user.feature = `operation_onboard_parties`

    this.requestAddressSave()
  }

  requestAddressSave() {
    if (this.addressActionMode == "new") {
      var url = "/users/accounts/addresses/create"
      var method = "POST"
    } else if (this.addressActionMode == "edit") {
      var url = "/users/accounts/addresses/update"
      var method = "PUT"
    }
    var controller = this
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_address) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.stopAddressRefreshing()
        if (response.save) {
          var address = response.data.cln
          controller.account.address = address
          controller.saveAddressBtnTarget.innerText = `Confirmado`
          controller.saveAddressBtnTarget.disabled = true
          controller.addressConfirmed = true
        } else {
          controller.saveAddressBtnTarget.innerText = `Salvar`
          controller.saveAddressBtnTarget.disabled = false
          controller.addressConfirmed = false
        }

        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  doAccountFormHtml() {
    this.stopAccountRefreshing()

    var html = `<div class="" style="width:100%;display:relative;" data-${this.controllerName}-target="formCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title f-065 p-1 mb-1" data-${this.controllerName}-target="formTitle">Criando ou Editando Médico</h6>
                  </div>
                  <div class="card-body p-0" style="overflow:auto;" data-${this.controllerName}-target="formCardBody">
                    <div class="row my-1">
                      <div class="col-6">
                        <div class="form-group form-valid-group">
                          <div class="floating-label floating-label-sm">
                            <label for="cpfForm">CPF Médico</label>
                            <input aria-describedby="cpfFormHelp" class="form-control form-valid-control" id="cpfForm" data-${this.controllerName}-target="cpfInput" data-action="blur->${this.controllerName}#cpfMask keypress->${this.controllerName}#cpfMask keyup->${this.controllerName}#searchAccount blur->${this.controllerName}#searchAccount keyup->${this.controllerName}#cpfValidate blur->${this.controllerName}#cpfValidate" placeholder="CPF Médico" type="text" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group form-valid-group">
                          <div class="floating-label floating-label-sm">
                            <label for="nameForm">Nome Médico</label>
                            <input aria-describedby="nameFormHelp" class="form-control form-valid-control" id="nameForm" data-${this.controllerName}-target="nameInput" placeholder="Nome Médico" type="text" required>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="row my-1">
                      <div class="col-6">
                        <div class="form-group form-valid-group">
                          <div class="floating-label floating-label-sm">
                            <label for="birthdateForm">Data Nascimento</label>
                            <input aria-describedby="birthdateFormHelp" class="form-control form-valid-control" id="birthdateForm" data-action="blur->${this.controllerName}#dateMask keypress->${this.controllerName}#dateMask keyup->${this.controllerName}#dateValidate blur->${this.controllerName}#dateValidate" data-${this.controllerName}-target="birthdateInput" placeholder="DD/MM/AAAA" type="text" required>
                          </div>
                        </div>
                      </div>
                      
                      <div class="col-6">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label>Sexo</label>
                            <div class="dropdown dropdown-selector" data-controller="app--helpers--search app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="sexDropdown">
                              <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="sexDropdownBtn"><span class="mr-auto w-100 selected-item" data-app--helpers--selector-target="input" data-${this.controllerName}-target="sexInput"></span></button>
                              <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                <input class="form-control form-control-selector" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchList" type="text" placeholder="Buscar ...">
                                <ul class="ul-select" data-${this.controllerName}-target="sexList" data-app--helpers--search-target="searchList">
                                  <li data-sex="male" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Masculino</li>
                                  <li data-sex="female" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Feminino</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row my-2">
                      <div class="col-4 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex mc-tooltip">
                          <input type="checkbox" class="custom-control-input" id="doctorCheck" data-${this.controllerName}-target="doctorCheckbox">
                          <label class="custom-control-label f-065 pointer" for="doctorCheck">Médico</label>
                          <span class="mc-tooltiptext">É médico?</span>
                        </div>
                      </div>
                      <div class="col-4 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex mc-tooltip">
                          <input type="checkbox" class="custom-control-input" id="operationalCheck" data-${this.controllerName}-target="operationalCheckbox">
                          <label class="custom-control-label f-065 pointer" for="operationalCheck">Operacional</label>
                          <span class="mc-tooltiptext">Emite NF pela PJ Médica?</span>
                        </div>
                      </div>
                      <div class="col-4 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex mc-tooltip">
                          <input type="checkbox" class="custom-control-input" id="financialCheck" data-${this.controllerName}-target="financialCheckbox">
                          <label class="custom-control-label f-065 pointer" for="financialCheck">Financeiro</label>
                          <span class="mc-tooltiptext">É financeiro da PJ?</span>
                        </div>
                      </div>
                    </div>

                    <div class="row my-2">
                      <div class="col-4 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex mc-tooltip">
                          <input type="checkbox" class="custom-control-input" id="administrativeCheck" data-${this.controllerName}-target="administrativeCheckbox">
                          <label class="custom-control-label f-065 pointer" for="administrativeCheck">Administrador</label>
                          <span class="mc-tooltiptext">É o Sócio-Administrador?</span>
                        </div>
                      </div>
                      <div class="col-4 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex mc-tooltip">
                          <input type="checkbox" class="custom-control-input" id="legalCheck" data-${this.controllerName}-target="legalCheckbox">
                          <label class="custom-control-label f-065 pointer" for="legalCheck">Legal</label>
                          <span class="mc-tooltiptext">É o Responsável-Legal?</span>
                        </div>
                      </div>
                      <div class="col-4 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex mc-tooltip">
                          <input type="checkbox" class="custom-control-input" id="technicalCheck" data-${this.controllerName}-target="technicalCheckbox">
                          <label class="custom-control-label f-065 pointer" for="technicalCheck">Técnico</label>
                          <span class="mc-tooltiptext">É o Responsável Técnico?</span>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-2 mb-4">
                      <div class="col-12 text-right">
                        <button type="button" class="btn btn-secondary btn-sm py-2 f-065" data-action="click->${this.controllerName}#cancelSaveParty">Fechar</button>
                        <button type="button" class="btn btn-primary btn-sm py-2 f-065" data-action="click->${this.controllerName}#saveAccount" data-${this.controllerName}-target="saveAccountBtn"></button>
                      </div>
                    </div>               
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--onboards--show--parties").formAccountPartyBodyTarget.innerHTML = html)
    }).then(() => {
      controller.refreshSaveAccountBtn()
      controller.formCardTarget.style.height = ($(controller.getControllerByIdentifier("operations--onboards--show--parties").formBodyTarget)[0].offsetHeight * 0.9) + "px"

      if (controller.party.id) {
        controller.onboardActionMode = `edit`
        controller.searchPartyAccount()
        controller.nameInputTarget.disabled = false
        controller.birthdateInputTarget.disabled = false
        controller.sexDropdownBtnTarget.disabled = false
        controller.saveAccountBtnTarget.innerText = `Salvar`

        controller.financialCheckboxTarget.checked = controller.party.party_financial
        controller.administrativeCheckboxTarget.checked = controller.party.party_administrative
        controller.operationalCheckboxTarget.checked = controller.party.party_operational
        controller.doctorCheckboxTarget.checked = controller.party.party_doctor
        controller.legalCheckboxTarget.checked = controller.party.party_legal
        controller.technicalCheckboxTarget.checked = controller.party.party_technical

        controller.cpfInputTarget.value = controller.party.party_number_pretty
        controller.nameInputTarget.value = controller.party.party_name
        controller.account_id = controller.party.party_id
      } else {
        controller.onboardActionMode = `new`
        controller.nameInputTarget.disabled = true
        controller.birthdateInputTarget.disabled = true
        controller.sexDropdownBtnTarget.disabled = true
        controller.saveAccountBtnTarget.innerText = `Salvar`
      }

      if (controller.application.onboard.product_name == `medclinic`) {

      } else if (controller.application.onboard.product_name == `medfiling`) {
        controller.financialCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.administrativeCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.operationalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.legalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.technicalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
      } else if (controller.application.onboard.product_name == `medbooking`) {
        controller.financialCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.administrativeCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.operationalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.legalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.technicalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
      } else if (controller.application.onboard.product_name == `medreceivement`) {
        controller.financialCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.administrativeCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.operationalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.legalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.technicalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
      } else if (controller.application.onboard.product_name == `medpayroll`) {
        controller.operationalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.legalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.technicalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
      } else if (controller.application.onboard.product_name == `medconsulting`) {
      } else if (controller.application.onboard.product_name == `medbiling`) {
      } else if (controller.application.onboard.product_name == `medbanking`) {
        controller.financialCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.administrativeCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.operationalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.legalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
        controller.technicalCheckboxTarget.closest(`.col-4`).classList.add(`d-none`)
      }

      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    })
  }

  cpfMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToCpf(ev)
  }

  cpfValidate(ev) {
    var cleanCpf = this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(ev.target.value)
    if ((ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length == 11) || ev.type == "blur" && cleanCpf.length == 11) {
      this.cpf_result = this.getControllerByIdentifier("app--helpers--tax-number").cpf_validate(ev.target.value)
      if (this.cpf_result.invalid) {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.cpf_result.message, 3000)
        this.cpfInputTarget.classList.add("f-danger")
        this.cpfInputTarget.classList.remove("f-normal")
      } else {
        this.cpfInputTarget.classList.add("f-normal")
        this.cpfInputTarget.classList.remove("f-danger")
      }
    } else {
      this.cpfInputTarget.classList.add("f-normal")
      this.cpfInputTarget.classList.remove("f-danger")
    }
  }

  dateMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToDate(ev)
  }

  dateValidate(ev) {
    var cleanDate = this.getControllerByIdentifier("app--helpers--numbers").fromDateToNumber(ev.target.value)
    if ((ev.type == "keyup" && ev.shiftKey == false && cleanDate.length == 8) || ev.type == "blur" && cleanDate.length == 8) {
      this.checkDate = this.getControllerByIdentifier("app--helpers--date").checkDate(ev.target.value)
      if (this.checkDate.valid) {
        this.birthdateInputTarget.classList.add("f-normal")
        this.birthdateInputTarget.classList.remove("f-danger")
      } else {
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", this.checkDate.message, 3000)
        this.birthdateInputTarget.classList.add("f-danger")
        this.birthdateInputTarget.classList.remove("f-normal")
      }
    } else {
      this.birthdateInputTarget.classList.add("f-normal")
      this.birthdateInputTarget.classList.remove("f-danger")
    }
  }

  searchAccount(ev) {
    ev.preventDefault()
    ev.stopPropagation()
    ev.stopImmediatePropagation()
    var cleanCpf = this.getControllerByIdentifier("app--helpers--numbers").fromCpfToNumber(ev.target.value)
    if (ev.type == "keyup" && cleanCpf.length < 11) {
      this.nameInputTarget.value = ""
      this.birthdateInputTarget.value = ""
      this.sexDropdownTarget.value = ""
      this.sexInputTarget.innerText = ""
      this.sexInputTarget.dataset.sex = ""

      this.nameInputTarget.disabled = true
      this.birthdateInputTarget.disabled = true
      this.sexDropdownBtnTarget.disabled = true


      // } else if ((ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length == 11) || ev.type == "blur" && cleanCpf.length == 11 && this.nameInputTarget.value == "") {

    } else if (ev.type == "keyup" && ev.shiftKey == false && cleanCpf.length == 11 && this.canRequest) {
      this.canRequest = false
      this.cpf_result = this.getControllerByIdentifier("app--helpers--tax-number").cpf_validate(ev.target.value)
      var data = { account: { cpf: cleanCpf, kind: "doctor" }, current_user: { current_user_id: this.application.current_user.id, feature: "operation_onboard_parties" } }
      const url = "/users/accounts/entities/read"
      const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }

      if (this.cpf_result.invalid == false) {

        var hasProduct = false
        if (hasProduct) {
          this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", "O Médico já possui o produto Declaração de Ajuste Anual", 2000)
          this.setErrorMessage("O Médico já possui o produto Declaração de Ajuste Anual")
        } else {
          var controller = this
          fetch(url, init)
            .then(response => response.json())
            .then(response => {
              controller.canRequest = true
              if (response.process) {
                var account = response.data.cln
                controller.account_id = account.id

                if (account.id) {
                  controller.nameInputTarget.value = account.name
                  controller.birthdateInputTarget.value = account.birthdate_pretty
                  controller.sexInputTarget.innerText = account.sex_pretty
                  controller.sexInputTarget.dataset.sex = account.sex
                  controller.sexDropdownTarget.value = account.sex

                  controller.nameInputTarget.disabled = true
                  controller.sexDropdownBtnTarget.disabled = true
                  if (controller.birthdateInputTarget.value == account.birthdate_pretty) {
                    controller.birthdateInputTarget.disabled = true
                  } else {
                    controller.birthdateInputTarget.disabled = false
                  }
                  controller.formTitleTarget.innerText = `Editando Médico`
                  controller.saveAccountBtnTarget.classList.remove("d-none")
                  controller.saveAccountBtnTarget.innerText = `Confirmar`
                  controller.accountActionMode = `edit`
                } else {
                  controller.formTitleTarget.innerText = `Criando Médico`
                  controller.nameInputTarget.value = "Favor adicionar o Nome do Médico"
                  controller.birthdateInputTarget.value = ""
                  controller.sexDropdownTarget.value = ""
                  controller.sexInputTarget.innerText = ""
                  controller.sexInputTarget.dataset.sex = ""

                  controller.nameInputTarget.disabled = false
                  controller.birthdateInputTarget.disabled = false
                  controller.sexDropdownBtnTarget.disabled = false

                  controller.saveAccountBtnTarget.classList.remove("d-none")
                  controller.saveAccountBtnTarget.innerText = `Salvar`
                  controller.accountActionMode = `new`
                }

                controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
              }
              
              controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
            })
            .catch(error => {
              controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
            })
        }
      }
    }
  }

  searchPartyAccount() {
    var data = { account: { id: this.party.party_id }, current_user: { current_user_id: this.application.current_user.id, feature: "operation_onboard_parties" } }
    const url = "/users/accounts/entities/read"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }

    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          var account = response.data.cln
          controller.account_id = account.id
          controller.nameInputTarget.value = account.name
          controller.birthdateInputTarget.value = account.birthdate_pretty
          controller.sexInputTarget.innerText = account.sex_pretty
          controller.sexInputTarget.dataset.sex = account.sex
          controller.sexDropdownTarget.value = account.sex

          controller.nameInputTarget.disabled = true
          controller.sexDropdownBtnTarget.disabled = true
          if (controller.birthdateInputTarget.value == account.birthdate_pretty) {
            controller.birthdateInputTarget.disabled = true
          } else {
            controller.birthdateInputTarget.disabled = false
          }
          controller.formTitleTarget.innerText = `Editando Médico`
          controller.saveAccountBtnTarget.classList.remove("d-none")
          controller.saveAccountBtnTarget.innerText = `Confirmar`
          controller.accountActionMode = `edit`


          controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
        }
        
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  setErrorMessage(message) {
    this.errorMessageTarget.innerText = message
    var controller = this
    setTimeout(() => {
      controller.errorMessageTarget.innerText = ``
    }, 3000);
  }


  doContactFormHtml() {
    this.stopPhoneRefreshing()
    this.stopEmailRefreshing()
    this.stopAddressRefreshing()

    this.phoneConfirmed = false
    this.emailConfirmed = false
    this.addressConfirmed = false

    var html = `<div class="" style="width:100%;display:relative;" data-${this.controllerName}-target="formCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title f-065 p-1 mb-1" data-${this.controllerName}-target="formTitle">Contatos da PF Médica</h6>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="formCardBody">
                    <div class="row my-1">
                      <div class="col-3 px-1">
                        <div class="floating-label floating-label-sm">
                          <label>Tipo</label>
                          <div class="dropdown dropdown-selector" data-controller="app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="kindPhoneDropdown">
                            <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:29px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="kindPhoneDropdownBtn"><span class="mr-auto w-100 selected-item f-065" id="selected" data-app--helpers--selector-target="input" data-${this.controllerName}-target="kindPhoneInput"></span></button>
                            <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                              <input class="form-control form-control-selector f-065" type="text" placeholder="Buscar ...">
                              <ul class="ul-select" data-${this.controllerName}-target="kindPhoneList">
                                <li data-kind="personal" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Pessoal</li>
                                <li data-kind="commercial" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Comercial</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="dddInput">DDD</label>
                            <input id="dddInput" data-${this.controllerName}-target="dddInput" class="form-control p-1 s-title-0p6rem" type="tel" data-action="blur->${this.controllerName}#dddMask keyup->${this.controllerName}#dddMask" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="phoneInput">Número</label>
                            <input id="phoneInput" data-${this.controllerName}-target="phoneInput" class="form-control p-1 s-title-0p6rem" type="tel" data-action="blur->${this.controllerName}#phoneMask keyup->${this.controllerName}#phoneMask" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 px-1 d-flex align-items-center justify-content-end">
                        <button type="button" class="btn btn-primary btn-sm btn-table py-2 px-1 f-065" data-action="click->${this.controllerName}#savePhone" data-${this.controllerName}-target="savePhoneBtn"></button>
                      </div>
                    </div>

                    <div class="row my-1">
                      <div class="col-3 px-1">
                        <div class="floating-label floating-label-sm">
                          <label>Tipo</label>
                          <div class="dropdown dropdown-selector" data-controller="app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="kindEmailDropdown">
                            <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:29px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="kindEmailDropdownBtn"><span class="mr-auto w-100 selected-item f-065" id="selected" data-app--helpers--selector-target="input" data-${this.controllerName}-target="kindEmailInput"></span></button>
                            <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                              <input class="form-control form-control-selector dropdown-search-input f-065" type="text" placeholder="Buscar ...">
                              <ul class="ul-select" data-${this.controllerName}-target="kindEmailList">
                                <li data-kind="personal" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Pessoal</li>
                                <li data-kind="commercial" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Comercial</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-5 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="addressInput">E-mail</label>
                            <input id="addressInput" data-${this.controllerName}-target="addressInput" class="form-control p-1 s-title-0p6rem" type="email" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 px-1 d-flex align-items-center justify-content-end">
                        <button type="button" class="btn btn-primary btn-sm btn-table py-2 px-1 f-065" data-action="click->${this.controllerName}#saveEmail" data-${this.controllerName}-target="saveEmailBtn"></button>
                      </div>
                    </div>

                    <div class="row my-1">
                      <div class="col-3 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label>Tipo</label>
                            <div class="dropdown dropdown-selector" data-controller="app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="kindAddressDropdown">
                              <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:29px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="kindAddressDropdownBtn"><span class="mr-auto w-100 selected-item f-065" id="selected" data-app--helpers--selector-target="input" data-${this.controllerName}-target="kindAddressInput"></span></button>
                              <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                <input class="form-control form-control-selector dropdown-search-input f-065" type="text" placeholder="Buscar ...">
                                <ul class="ul-select" data-${this.controllerName}-target="kindAddressList">
                                  <li data-kind="personal" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Pessoal</li>
                                  <li data-kind="commercial" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Comercial</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="zipInput">CEP</label>
                            <input id="zipInput" data-${this.controllerName}-target="zipInput" class="form-control p-1 s-title-0p6rem" type="tel" data-action="blur->${this.controllerName}#zipMask keyup->${this.controllerName}#zipMask focus->${this.controllerName}#searchZip blur->${this.controllerName}#searchZip keyup->${this.controllerName}#searchZip" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="ibgeInput">IBGE</label>
                            <input id="ibgeInput" data-${this.controllerName}-target="ibgeInput" class="form-control p-1 s-title-0p6rem" type="tel" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 px-1 d-flex align-items-center justify-content-end">
                        <button type="button" class="btn btn-primary btn-sm btn-table py-2 px-1 f-065" data-action="click->${this.controllerName}#saveAddress" data-${this.controllerName}-target="saveAddressBtn"></button>
                      </div>
                    </div>
                    <div class="row my-1">
                      <div class="col-6 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="streetInput">Logradouro</label>
                            <input id="streetInput" data-${this.controllerName}-target="streetInput" class="form-control p-1 s-title-0p6rem" type="text" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="numberInput">Número</label>
                            <input id="numberInput" data-${this.controllerName}-target="numberInput" class="form-control p-1 s-title-0p6rem" type="text" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="complementInput">Complemento</label>
                            <input id="complementInput" data-${this.controllerName}-target="complementInput" class="form-control p-1 s-title-0p6rem" type="text" required>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row my-1">
                      <div class="col-5 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="districtInput">Bairro</label>
                            <input id="districtInput" data-${this.controllerName}-target="districtInput" class="form-control p-1 s-title-0p6rem" type="text" required>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="stateForm">UF</label>
                            <input aria-describedby="stateFormHelp" class="form-control p-1 s-title-0p6rem" id="stateForm" data-filter-mode="simple" data-${this.controllerName}-target="stateInput" data-action="focus->${this.controllerName}#stateFilter keyup->${this.controllerName}#stateFilter blur->${this.controllerName}#hideList" placeholder="UF" type="text" required>
                            <ul class="ul-filter filter-list d-none w-100" style="z-index:1" data-${this.controllerName}-target="stateFilter">
                              <li data-filter="MG" data-text="MG" data-state="MG" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">MG</li>
                              <li data-filter="SP" data-text="SP" data-state="SP" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">SP</li>
                              <li data-filter="AC" data-text="AC" data-state="AC" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">AC</li>
                              <li data-filter="AL" data-text="AL" data-state="AL" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">AL</li>
                              <li data-filter="AP" data-text="AP" data-state="AP" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">AP</li>
                              <li data-filter="AM" data-text="AM" data-state="AM" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">AM</li>
                              <li data-filter="BA" data-text="BA" data-state="BA" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">BA</li>
                              <li data-filter="CE" data-text="CE" data-state="CE" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">CE</li>
                              <li data-filter="DF" data-text="DF" data-state="DF" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">DF</li>
                              <li data-filter="ES" data-text="ES" data-state="ES" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">ES</li>
                              <li data-filter="GO" data-text="GO" data-state="GO" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">GO</li>
                              <li data-filter="MA" data-text="MA" data-state="MA" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">MA</li>
                              <li data-filter="MT" data-text="MT" data-state="MT" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">MT</li>
                              <li data-filter="MS" data-text="MS" data-state="MS" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">MS</li>
                              <li data-filter="PA" data-text="PA" data-state="PA" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">PA</li>
                              <li data-filter="PB" data-text="PB" data-state="PB" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">PB</li>
                              <li data-filter="PR" data-text="PR" data-state="PR" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">PR</li>
                              <li data-filter="PE" data-text="PE" data-state="PE" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">PE</li>
                              <li data-filter="PI" data-text="PI" data-state="PI" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">PI</li>
                              <li data-filter="RJ" data-text="RJ" data-state="RJ" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">RJ</li>
                              <li data-filter="RN" data-text="RN" data-state="RN" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">RN</li>
                              <li data-filter="RS" data-text="RS" data-state="RS" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">RS</li>
                              <li data-filter="RO" data-text="RO" data-state="RO" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">RO</li>
                              <li data-filter="RR" data-text="RR" data-state="RR" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">RR</li>
                              <li data-filter="SC" data-text="SC" data-state="SC" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">SC</li>
                              <li data-filter="SE" data-text="SE" data-state="SE" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">SE</li>
                              <li data-filter="TO" data-text="TO" data-state="TO" data-action="click->${this.controllerName}#selectState click->${this.controllerName}#getCities" class="li-selector dark">TO</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-5 px-1">
                        <div class="form-group">
                          <div class="floating-label floating-label-sm">
                            <label for="cityForm">Cidade</label>
                            <input aria-describedby="cityFormHelp" class="form-control p-1 s-title-0p6rem" id="cityForm" data-filter-mode="simple" data-${this.controllerName}-target="cityInput" data-action="focus->${this.controllerName}#cityFilter keyup->${this.controllerName}#cityFilter blur->${this.controllerName}#hideList" placeholder="Cidade" type="text" required>
                            <ul class="ul-filter filter-list d-none w-100" style="z-index:1" data-${this.controllerName}-target="cityFilter"></ul>
                          </div>
                        </div>
                      </div>
                    </div>
           
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--onboards--show--parties").formAccountPartyBodyTarget.innerHTML = html)
    }).then(() => {
      controller.refreshSaveContactBtn()
      controller.formCardTarget.style.height = ($(window).height() * 0.4) + "px"

      if (controller.account.phone.id) {
        controller.phoneActionMode = `edit`
        controller.savePhoneBtnTarget.innerText = `Confirmar`
        controller.dddInputTarget.value = controller.account.phone.ddd
        controller.phoneInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").phoneMask(controller.account.phone.number)
        controller.kindPhoneInputTarget.dataset.kind = controller.account.phone.kind
        controller.kindPhoneInputTarget.innerText = controller.account.phone.kind_pretty
        controller.kindPhoneDropdownTarget.value = controller.account.phone.kind_pretty
      } else {
        controller.phoneActionMode = `new`
        controller.savePhoneBtnTarget.innerText = `Salvar`
      }

      if (controller.account.email.id) {
        controller.emailActionMode = `edit`
        controller.saveEmailBtnTarget.innerText = `Confirmar`
        controller.addressInputTarget.value = controller.account.email.address
        controller.kindEmailInputTarget.dataset.kind = controller.account.email.kind
        controller.kindEmailInputTarget.innerText = controller.account.email.kind_pretty
        controller.kindEmailDropdownTarget.value = controller.account.email.kind_pretty
      } else {
        controller.emailActionMode = `new`
        controller.saveEmailBtnTarget.innerText = `Salvar`
      }

      if (controller.account.address.id) {
        controller.addressActionMode = `edit`
        controller.saveAddressBtnTarget.innerText = `Confirmar`
        controller.zipInputTarget.value = this.getControllerByIdentifier("app--helpers--numbers").zipMask(controller.account.address.postal_code)
        controller.streetInputTarget.value = controller.account.address.street
        controller.numberInputTarget.value = controller.account.address.number
        controller.complementInputTarget.value = controller.account.address.complement
        controller.districtInputTarget.value = controller.account.address.district
        controller.cityInputTarget.value = controller.account.address.city
        controller.stateInputTarget.value = controller.account.address.state
        controller.ibgeInputTarget.value = controller.account.address.ibge
        controller.kindAddressInputTarget.dataset.kind = controller.account.address.kind
        controller.kindAddressInputTarget.innerText = controller.account.address.kind_pretty
        controller.kindAddressDropdownTarget.value = controller.account.address.kind_pretty
      } else {
        controller.addressActionMode = `new`
        controller.saveAddressBtnTarget.innerText = `Salvar`
      }

      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    })
  }

  phoneMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToPhone(ev)
  }

  dddMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToDDD(ev)
  }

  searchZip(ev) {

    if ((ev.type == "keyup" && this.zipInputTarget.value.length == 10) || (ev.type == "keyup" && ev.key == "Enter" && ev.shiftKey == false && this.zipInputTarget.value.length == 10) || (ev.type == "blur")) {
      var cep = this.getControllerByIdentifier("app--helpers--numbers").fromZipToNumber(this.zipInputTarget.value).replace(/\D/g, '')
      var controller = this
      if (cep != "") {
        var validacep = /^[0-9]{8}$/;
        if (validacep.test(cep)) {
          $.getJSON("//viacep.com.br/ws/" + cep + "/json?callback=?", function (dados) {
            if (!("erro" in dados)) {
              if (dados.logradouro === "") {
                controller.streetInputTarget.disabled = false
              } else {
                controller.streetInputTarget.value = dados.logradouro
                controller.send_address.address.street = dados.logradouro
              }
              if (dados.bairro === "") {
                controller.districtInputTarget.disabled = false
              } else {
                controller.districtInputTarget.value = dados.bairro
                controller.send_address.address.district = dados.bairro
              }
              if (dados.uf === "") {
                controller.stateInputTarget.disabled = false
              } else {
                controller.stateInputTarget.value = dados.uf
                controller.stateInputTarget.dataset.filter = dados.uf
                controller.send_address.address.state = dados.uf
              }
              if (dados.localidade === "") {
                controller.cityInputTarget.disabled = false
              } else {
                controller.cityInputTarget.value = dados.localidade
                controller.cityInputTarget.dataset.filter = dados.localidade
                controller.send_address.address.city = dados.localidade
              }
              if (dados.ibge === "") {
                controller.ibgeInputTarget.disabled = false
              } else {
                controller.ibgeInputTarget.value = dados.ibge
                controller.send_address.address.ibge = dados.ibge
              }
              controller.send_address.address.country = `Brasil`
              controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
            } else {
              controller.cleanForm();
              controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", `CEP não encontrado, favor preencher as informações manualmente`, 5000)
            }
          });

        }
        else {
          controller.cleanForm();
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", `CEP não encontrado, favor preencher as informações manualmente`, 5000)
        }
      }
      else {
        this.cleanForm();
        this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", `CEP não encontrado, favor preencher as informações manualmente`, 5000)
      }
    } else if (ev.type == "focus" && this.zipInputTarget.value.length < 10) {
      this.closeForm();
    }
  }

  cityFilter(ev) {
    this.getControllerByIdentifier("app--helpers--input").filterList(ev, 3)
  }

  stateFilter(ev) {
    this.getControllerByIdentifier("app--helpers--input").filterList(ev, 0)
  }

  hideList(ev) {
    // this.getControllerByIdentifier("app--helpers--input").hideList(ev)
  }

  getCities(ev) {
    var state = ev.currentTarget.dataset.state
    this.getCitiesByState(state)
  }

  getCitiesByState(state) {
    var data = { state: { state: state }, current_user: { current_user_id: this.application.current_user_id } }
    const url = "/users/accounts/addresses/cities_by_state"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          var listHtml = ``
          response.data.cln.forEach(element => {
            // listHtml += `<li data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" data-city="${element}" class="li-selector dark">${element}</li>`
            listHtml += `<li data-city="${element}" data-filter="${element}" data-text="${element}" data-action="click->${this.controllerName}#selectCity" class="li-selector dark">${element}</li>`
          });
          this.cityFilterTarget.innerHTML = listHtml
          // this.cityListTarget.innerHTML = listHtml
        }
        
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  selectCity(ev) {
    this.getControllerByIdentifier("app--helpers--input").selectItem(ev)
  }

  selectState(ev) {
    this.getControllerByIdentifier("app--helpers--input").selectItem(ev)
  }

  zipMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToZip(ev)
  }

  cleanForm() {
    this.streetInputTarget.value = ``
    this.numberInputTarget.value = ``
    this.complementInputTarget.value = ``
    this.districtInputTarget.value = ``
    this.cityInputTarget.value = ``
    this.cityInputTarget.dataset.filter = ``
    this.stateInputTarget.value = ``
    this.stateInputTarget.dataset.filter = ``

    this.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    this.streetInputTarget.disabled = false
    this.districtInputTarget.disabled = false
    this.stateInputTarget.disabled = false
    this.cityInputTarget.disabled = false

    this.send_address.address.postal_code = ``
    this.send_address.address.street = ``
    this.send_address.address.number = ``
    this.send_address.address.complement = ``
    this.send_address.address.district = ``
    this.send_address.address.city = ``
    this.send_address.address.state = ``
    this.send_address.address.country = ``
    this.send_address.address.ibge = ``
  }

  closeForm() {
    this.streetInputTarget.value = ``
    this.numberInputTarget.value = ``
    this.complementInputTarget.value = ``
    this.districtInputTarget.value = ``
    this.cityInputTarget.value = ``
    this.cityInputTarget.dataset.filter = ``
    this.stateInputTarget.value = ``
    this.stateInputTarget.dataset.filter = ``

    this.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    this.streetInputTarget.disabled = true
    this.districtInputTarget.disabled = true
    this.stateInputTarget.disabled = true
    this.cityInputTarget.disabled = true

    this.send_address.address.postal_code = ``
    this.send_address.address.street = ``
    this.send_address.address.number = ``
    this.send_address.address.complement = ``
    this.send_address.address.district = ``
    this.send_address.address.city = ``
    this.send_address.address.state = ``
    this.send_address.address.country = ``
    this.send_address.address.ibge = ``
  }

  doInfoHTML() {
    var html = `<div data-controller="users--accounts--documents--info" data-users--accounts--documents--info-target="main"></div>`
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--onboards--show--parties").formAccountPartyBodyTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`users--accounts--documents--info`).current_account = controller.account
      controller.getControllerByIdentifier(`users--accounts--documents--info`).permission = `operation_onboard_parties`
      controller.getControllerByIdentifier(`users--accounts--documents--info`).setCurrentInfo()
      controller.getControllerByIdentifier(`users--accounts--documents--info`).saveBtnTarget.classList.remove("d-none")
      controller.refreshSaveInfo()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["formCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveAccountBtn() {
    var controller = this
    this.refreshAccountTimer = setInterval(function () {
      var len = 0

      if (controller.hasSaveAccountBtnTarget) {
        if (controller.cpf_result && controller.cpf_result.invalid) {
          len += 1
        }

        if (controller.hasCpfInputTarget && controller.cpfInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasNameInputTarget && controller.nameInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasBirthdateInputTarget && controller.birthdateInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasSexInputTarget && controller.sexInputTarget.innerText == ``) {
          len += 1
        }

        // if (controller.mrrInputTarget && controller.mrrInputTarget.innerText == ``) {
        //   len += 1
        // }

        if (len == 0) {
          controller.saveAccountBtnTarget.disabled = false
        } else {
          controller.saveAccountBtnTarget.disabled = true
        }
      } else {
        controller.stopAccountRefreshing()
      }

    }, 200);
  }

  refreshSaveContactBtn() {
    var controller = this

    this.refreshPhoneTimer = setInterval(function () {
      var len = 0

      if (controller.hasSavePhoneBtnTarget) {
        if (controller.hasDddInputTarget && controller.dddInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasPhoneInputTarget && controller.phoneInputTarget.value == ``) {
          len += 1
        }

        if (len == 0) {
          controller.savePhoneBtnTarget.disabled = false
        } else {
          controller.savePhoneBtnTarget.disabled = true
        }
      } else {
        controller.stopPhoneRefreshing()
        controller.stopRefreshing()
      }

    }, 200);

    this.refreshEmailTimer = setInterval(function () {
      var len = 0

      if (controller.hasSaveEmailBtnTarget) {
        if (controller.hasAddressInputTarget && controller.addressInputTarget.value == ``) {
          len += 1
        }

        if (len == 0) {
          controller.saveEmailBtnTarget.disabled = false
        } else {
          controller.saveEmailBtnTarget.disabled = true
        }
      } else {
        controller.stopEmailRefreshing()
        controller.stopRefreshing()
      }

    }, 200);

    this.refreshAddressTimer = setInterval(function () {
      var len = 0

      if (controller.hasSaveAddressBtnTarget) {
        if (controller.hasZipInputTarget && controller.zipInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasStreetInputTarget && controller.streetInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasNumberInputTarget && controller.numberInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasDistrictInputTarget && controller.districtInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasCityInputTarget && controller.cityInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasStateInputTarget && controller.stateInputTarget.value == ``) {
          len += 1
        }

        if (controller.hasIbgeInputTarget && controller.ibgeInputTarget.value == ``) {
          len += 1
        }

        if (len == 0) {
          controller.saveAddressBtnTarget.disabled = false
        } else {
          controller.saveAddressBtnTarget.disabled = true
        }
      } else {
        controller.stopAddressRefreshing()
        controller.stopRefreshing()
      }

    }, 200);

    this.refreshTimer = setInterval(function () {
      var len = 0

      if (!controller.phoneConfirmed) {
        len += 1
      }

      if (!controller.emailConfirmed) {
        len += 1
      }

      if (!controller.addressConfirmed) {
        len += 1
      }

      if (len == 0) {
        // controller.cancelSaveParty()
        controller.stopContactRefreshing()
        controller.doInfoHTML()
        controller.getControllerByIdentifier("operations--onboards--show--entity").setParties()
      } else {
        controller.getControllerByIdentifier("operations--onboards--show--parties").partiesActions(true)
      }
    }, 200);
  }

  refreshSaveInfo() {
    var controller = this
    this.refreshInfoTimer = setInterval(function () {
      var len = 0

      if (controller.getControllerByIdentifier(`users--accounts--documents--info`)) {

        var controllerInfo = controller.getControllerByIdentifier(`users--accounts--documents--info`)

        if (controllerInfo.occupationDivTarget.innerText == `` || controllerInfo.occupationDivTarget.classList.contains("d-none")) {
          len += 1
        }

        if (controllerInfo.sourceDivTarget.innerText == `` || controllerInfo.sourceDivTarget.classList.contains("d-none")) {
          len += 1
        }

        if (controllerInfo.maritalStatusDivTarget.innerText == `` || controllerInfo.maritalStatusDivTarget.classList.contains("d-none")) {
          len += 1
        }

        if (!controllerInfo.saveBtnTarget.classList.contains("d-none")) {
          len += 1
        }

        if (len == 0) {
          controller.cancelSaveParty()
        } else {
          controller.getControllerByIdentifier("operations--onboards--show--parties").partiesActions(true)
        }
      } else {
        controller.stopInfoRefreshing()
      }

    }, 200);
  }

  cancelSaveParty() {
    this.stopAllRefreshing()
    this.getControllerByIdentifier("operations--onboards--show--parties").partiesActions(false)
  }

  stopContactRefreshing() {
    this.stopAccountRefreshing()
    this.stopPhoneRefreshing()
    this.stopEmailRefreshing()
    this.stopAddressRefreshing()
    this.stopRefreshing()
  }

  stopAllRefreshing() {
    this.stopInfoRefreshing()
    this.stopAccountRefreshing()
    this.stopPhoneRefreshing()
    this.stopEmailRefreshing()
    this.stopAddressRefreshing()
    this.stopRefreshing()
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  stopAccountRefreshing() {
    if (this.refreshAccountTimer) {
      clearInterval(this.refreshAccountTimer)
    }
  }

  stopPhoneRefreshing() {
    if (this.refreshPhoneTimer) {
      clearInterval(this.refreshPhoneTimer)
    }
  }

  stopEmailRefreshing() {
    if (this.refreshEmailTimer) {
      clearInterval(this.refreshEmailTimer)
    }
  }

  stopAddressRefreshing() {
    if (this.refreshAddressTimer) {
      clearInterval(this.refreshAddressTimer)
    }
  }

  stopInfoRefreshing() {
    if (this.refreshInfoTimer) {
      clearInterval(this.refreshInfoTimer)
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}